// Package imports:
import React, { useState } from 'react';
// Component imports:
import PriceCard from '../../PriceCard/PriceCard';
import SignUpForm from '../SignUpForm/SignUpForm';
import Link from '../../../ui-elements/Link/Link';
// Service imports:
import { formatNumber } from '../../../services/utils';
// Type imports:
import { AppSubOption, AppAddOns, IPriceInfo } from '../../../types/SignUpTypes';

import { APP_PRICES } from '../../KeldanAppPage/KeldanAppPage';

interface IProps {
    subChoice?: AppSubOption,
    addons?: AppAddOns[]
}

const AppSignUpPage: React.FC<IProps> = () => {
    const { search } = window.location;
    const query = new URLSearchParams(search);
    const subscriptionChoice: AppSubOption = (query.get('plan') as AppSubOption) ?? 'company';
    const addOns: AppAddOns[] = (query.get('addons')?.split(';') as AppAddOns[]) ?? ['company_shares_1', 'company_bonds_all'];
    const price = 2900;
    const [activeStep, setActiveStep] = useState(0);
    const addOnItems: (IPriceInfo | undefined)[] = subscriptionChoice === 'individual' ? [APP_PRICES.individuals.find(x => x.id === addOns[0])] : APP_PRICES.companies.filter(x => addOns.includes(x.id as AppAddOns));
    return (
        <div className='main KCL_sign-up-page'>
            <div className="main__inner">
                <div className="section section--signup">
                    <div className="section__head">
                        <div className="shell">
                            {activeStep === 0
                                ? <h1>Áskrift að Keldan App Premium</h1>
                                : activeStep === 1
                                ? <h1>Yfirfara upplýsingar</h1>
                                : <h1>Velkomin/n í áskrift</h1>
                            }
                        </div>
                    </div>
                    <div className="section__body">
                        <div className="shell">
                            <div className="section__body-inner">
                                <aside className="section__aside">
                                    {subscriptionChoice === 'individual'
                                        ? <PriceCard
                                            className="price-card--signup"
                                            variant="primary"
                                            type="Einstaklingar"
                                            price={formatNumber(price, null, 0)}
                                            priceInfo="kr. á mánuði + VSK"
                                            badge="Þitt val"
                                        >
                                            <p className="price-subtext">Ásamt mánaðargjaldi að markaðsgögnum.*</p>
                                            {addOnItems[0] && <p>{addOnItems[0].name} {addOnItems[0].description}, {formatNumber(addOnItems[0].price, null, 0)} {addOnItems[0].currency}</p>}
                                        </PriceCard>
                                        : subscriptionChoice === 'company' 
                                        ? <PriceCard
                                            className="price-card--signup"
                                            showRibbon
                                            variant="secondary"
                                            type="Fyrirtæki"
                                            price={formatNumber(price, null, 0)}
                                            priceInfo="kr. á mánuði + VSK"
                                            badge="Þitt val"
                                        >
                                            <p className="price-subtext">Ásamt mánaðargjaldi að markaðsgögnum.*</p>
                                            {addOnItems.map((addOn: IPriceInfo | undefined) => (
                                                <p>{addOn?.name} {addOn?.description}, {formatNumber(addOn?.price, null, 0)} {addOn?.currency}</p>
                                            ))}
                                        </PriceCard>
                                        : null
                                    }
                                    <p>Ekki rétt valið? <Link url="/Keldan-App" linkSize='16'>Farðu til baka til að breyta</Link></p>
                                </aside>
                                <div className="section__content">
                                    <SignUpForm
                                        signUpType='app'
                                        subscriptionChoice={subscriptionChoice}
                                        price={price}
                                        activeStep={activeStep}
                                        setActiveStep={setActiveStep}
                                        addOnItems={addOnItems}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AppSignUpPage;